import React from 'react';
import { Heading, TextBlock, ExtendedTheme, Children } from 'neon-design-system';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Grid, Box } from '@material-ui/core';

declare type Ink = 'default' | 'muted' | 'placeholder';

interface Props {
	title: Children | string;
	subtitle: Children | string;
	subtitleInk?: Ink;
	headerLink?: Children | string;
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
	createStyles({
		title: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between'
		},
		subTitle: {
			'& > a': {
				fontSize: 'inherit'
			}
		}
	})
);

const PageHeader = ({ title, subtitle, subtitleInk, headerLink }: Props) => {
	const classes = useStyles();

	return (
		<Grid container spacing={1}>
			<Grid item xs={12} className={classes.title}>
				<Heading
					styleName="largeTitle"
					xs="small"
					md="medium"
					xl="large"
				>
					{title}
				</Heading>
				<Box>
					{headerLink}
				</Box>
			</Grid>
			<Grid item xs={12}>
				<TextBlock
					styleName="largeBody2"
					xs="small"
					md="medium"
					xl="large"
					className={classes.subTitle}
					ink={subtitleInk}
				>
					{subtitle}
				</TextBlock>
			</Grid>
		</Grid>
	);
};

export default PageHeader;
